import { Scope, ScopeResource } from "src/authentication/PermissionsProvider";
import { usePermissions } from "src/authentication/usePermissions";
import { ClientSchemaProperty } from "src/types/clientSchema";

import { useGetCasePropertiesQuery } from "./CasePropertiesQuery";
import { useGetCustomerPropertiesQuery } from "./CustomerPropertiesQuery";

export const useGetPropertiesQuery = ({
  onError,
  caseTypeCode,
}: {
  onError: (error: Error) => void;
  caseTypeCode?: string;
}): {
  data: ClientSchemaProperty[];
  loading: boolean;
} => {
  const { hasPermission } = usePermissions();

  const caseQuery = useGetCasePropertiesQuery({ onError, caseTypeCode });
  const customerQuery = useGetCustomerPropertiesQuery({
    onError,
    skip: !hasPermission(ScopeResource.CUSTOMER, Scope.VIEW),
  });
  return {
    data: [...(caseQuery.data ?? []), ...(customerQuery.data ?? [])],
    loading: caseQuery.loading || customerQuery.loading,
  };
};
